import { AsyncPipe } from '@angular/common'
import { Component, inject } from '@angular/core'
import { MatDivider } from '@angular/material/divider'
import { AuthService, Principal, PrincipalService } from '@elderbyte/ngx-auth'
import {
  ElderAppHeaderComponent,
  ElderAppearanceSettingsComponent,
  ElderExpandToggleButtonComponent,
  ElderLanguageSwitcherComponent,
  ElderNavLinkComponent,
  ElderNavListComponent,
  ElderRailNavDirective,
  ElderShellComponent,
  ElderShellSideLeftDirective,
  ElderShellStaticNavSlotDirective,
  ElderTogglePanelComponent,
  ElderTogglePanelPrimaryDirective,
  ElderTogglePanelSecondaryDirective,
  ElderTogglePanelTriggerDirective,
  ElderToolbarColumnDirective,
  ElderTranslatePipe,
} from '@elderbyte/ngx-starter'
import { Observable } from 'rxjs'
import { environment } from '../../environments/environment'
import { MainNavMenuComponent } from './main-nav-menu/main-nav-menu.component'

@Component({
  selector: 'app-app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    ElderShellComponent,
    ElderToolbarColumnDirective,
    ElderLanguageSwitcherComponent,
    ElderShellSideLeftDirective,
    ElderAppHeaderComponent,
    ElderExpandToggleButtonComponent,
    ElderTogglePanelTriggerDirective,
    ElderTogglePanelComponent,
    ElderTogglePanelPrimaryDirective,
    ElderNavListComponent,
    ElderNavLinkComponent,
    MatDivider,
    ElderTogglePanelSecondaryDirective,
    ElderAppearanceSettingsComponent,
    AsyncPipe,
    ElderTranslatePipe,
    MainNavMenuComponent,
    ElderRailNavDirective,
    ElderShellStaticNavSlotDirective,
  ],
})
export class AppComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public version = environment.version
  private principalService = inject(PrincipalService)
  private authService = inject(AuthService)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}

  /***************************************************************************
   *                                                                         *
   * Account                                                                 *
   *                                                                         *
   **************************************************************************/

  public get accountUrl(): string {
    return environment.issuerUrl + '/account'
  }

  public get principal(): Observable<Principal> {
    return this.principalService.principalObservable
  }

  public login(): void {
    this.authService.goToLogin(location.pathname)
  }

  public logout(): void {
    this.authService.logout()
  }
}
